export const GLOSSARIO = 'GLOSSARIO';
export const GLOSSARIO_START = 'GLOSSARIO_START';
export const GLOSSARIO_SUCCESS = 'GLOSSARIO_SUCCESS';
export const GLOSSARIO_ERROR = 'GLOSSARIO_ERROR';

export const LETRA_SELECIONADA = 'LETRA_SELECIONADA';
